import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { REELS } from "@/data/site";

export default function ReelModal({ open, onClose }) {
    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    data-testid="showreel-modal-overlay"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.4 }}
                    className="fixed inset-0 z-[90] flex items-center justify-center bg-black/95 backdrop-blur-md p-4 sm:p-10"
                    onClick={onClose}
                >
                    <button
                        data-testid="showreel-modal-close-button"
                        onClick={onClose}
                        className="absolute top-5 right-5 sm:top-8 sm:right-10 flex h-12 w-12 items-center justify-center rounded-full border border-white/20 text-neutral-300 hover:border-[#FF3333] hover:text-[#FF3333] transition-colors"
                        aria-label="Close showreel"
                    >
                        <X size={18} />
                    </button>
                    <motion.div
                        initial={{ scale: 0.92, y: 30, opacity: 0 }}
                        animate={{ scale: 1, y: 0, opacity: 1 }}
                        exit={{ scale: 0.95, y: 20, opacity: 0 }}
                        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                        className="w-full max-w-6xl"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <p className="font-mono-x text-[10px] tracking-[0.4em] text-[#FF3333] mb-4">
                            2025 SIZZLE REEL - COMPOSITING / MATTE PAINTING / SET EXTENSIONS
                        </p>
                        <div className="relative aspect-video w-full overflow-hidden border border-white/10 bg-black">
                            <iframe
                                data-testid="showreel-youtube-iframe"
                                src={`https://www.youtube.com/embed/${REELS.y2025}?autoplay=1&rel=0`}
                                title="EXODUS FX 2025 Sizzle Reel"
                                className="absolute inset-0 h-full w-full"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                        </div>
                        <div className="mt-4 flex items-center justify-between">
                            <p className="font-mono-x text-[10px] tracking-[0.3em] text-neutral-500">
                                MATTE PAINTING - COMPOSITING - SET EXTENSIONS
                            </p>
                            <a
                                data-testid="showreel-2024-link"
                                href={`https://youtu.be/${REELS.y2024}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="font-mono-x text-[10px] tracking-[0.3em] text-neutral-400 hover:text-[#FF3333] transition-colors"
                            >
                                2024 REEL &#8599;
                            </a>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
